export default "__VITE_ASSET__DtxxPLMq__"